import wixData from 'wix-data';
import wixLocation from 'wix-location';

wixLocation.onChange((location) => {
    collectionsNav();
});

$w.onReady(function () {
    collectionsNav();
    $w("#collectionsRepeater").onItemReady(($item, itemData, index) => {

        $item("#colectionButton").label = itemData.name;
        $item("#colectionButton").link = itemData['link-collections-name'];

    });

});

async function collectionsNav() {
    var data = [];
    $w('#collectionsRepeater').data = [];
    let product = await $w('#productPage1').getProduct();
    console.log(product)
    let collections = await wixData.queryReferenced('Stores/Products', product._id, 'collections');

    if (collections.items) {
        let items = collections.items;

        for (var i = 0; i < items.length; i++) {
            if (items[i]._id !== "00000000-000000-000000-000000000001") {
                data.push(items[i]);
            }
        }

        $w('#collectionsRepeater').data = data;
        $w('#collectionsRepeater').expand();

    } else {
        $w('#collectionsRepeater').collapse();
    }

}